import {
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MultiSelectSearchItem } from '../../shared/models/MultiSelectSearchItem';

@Component({
  selector: 'multiselect-search',
  templateUrl: './multiselect-search.component.html',
  styleUrls: ['./multiselect-search.component.scss'],
})
export class MultiSelectSearchComponent {
  @Input() placeholder = 'Search by keyword';
  @Input() items: MultiSelectSearchItem[] = [];
  @Output() selectionChange = new EventEmitter<{
    id: number | string;
    isChecked: boolean;
  }>();

  searchQuery: string = '';
  filteredItems: MultiSelectSearchItem[] = [];

  constructor(private readonly elementRef: ElementRef) {}

  onSearch() {
    if (this.searchQuery) {
      // Dynamically filter based on all properties except `id` and `isChecked`
      this.filteredItems = this.items.filter((item) =>
        Object.keys(item)
          .filter((key) => key !== 'id' && key !== 'isChecked')
          .some((key) =>
            item[key]
              ?.toString()
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase()),
          ),
      );
    } else {
      this.filteredItems = [];
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.filteredItems = [];
    }
  }

  toggleSelection(itemId: number | string): void {
    const item = this.items.find((i) => i.id === itemId);
    if (item) {
      item.isChecked = !item.isChecked;
      this.selectionChange.emit({ id: item.id, isChecked: item.isChecked });
    }
  }

  clearSearch() {
    this.searchQuery = '';
    this.filteredItems = [];
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
